import { Observable } from 'rxjs';
import { Dashboard } from '../entities/dashboard.entity';

export interface DashboardFilter {
  portfolioId?: string[];
  portfolioIds?: string[];
  clientId?: string[];
  clientIds?: string[];
  status?: number[];
  orderCreatedAtFrom?: string;
  orderCreatedAtTo?: string;
  technicalUserIds?: string[];
  qualityControlStatus?: number[];
  qualityControlResults?: number[];
  qualityControlFinishedAtFrom?: string;
  qualityControlFinishedAtTo?: string;
}

export abstract class DashboardRepositoryPort {
  abstract getDashboard(filter?: DashboardFilter): Observable<Dashboard>;
  abstract refreshDashboard(filter?: DashboardFilter): Observable<Dashboard>;
}
